function debounce(func, delay) {
  let timer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}

class BydColFilters extends HTMLElement {
  constructor() {
    super();
    this.colSelectors = {
      input: '.byd-filters__filter-input[data-type-list]',
      inputCarat: '[carat-number-input]',
      inputCaratMin: '[carat-number-input-min]',
      inputCaratMax: '[carat-number-input-max]',
      inputPriceMax: '[data-filter-price-max]',
      inputPriceMin: '[data-filter-price-min]',
      inputsPrice: '[input-price-filter]',
      mainContainer: 'build-your-diamond',
      table: '.byd-table',
      loader: '.loading-fixed',
      clear: '.byd-filters__filter-clear',
    };
    this.filterUrls = [];
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.forEach((value, key) => {
      const encodeValue = encodeURIComponent(value)
      this.filterUrls.push(`${key}=${encodeValue}`);
    });
    this.previousUrl = window.location.href;
    this.initEvt();
  }
  initEvt() {
    this.clearBtn = document.querySelector(this.colSelectors.clear);
    this.colInputs = this.querySelectorAll(this.colSelectors.input);
    this.colInputsPrice = this.querySelectorAll(this.colSelectors.inputsPrice);

    this.inputPriceMin = this.querySelector(this.colSelectors.inputPriceMin);
    this.inputPriceMax = this.querySelector(this.colSelectors.inputPriceMax);

    this.inputCarat = this.querySelectorAll(this.colSelectors.inputCarat);
    this.inputCaratMin = this.querySelector(this.colSelectors.inputCaratMin);
    this.inputCaratMax = this.querySelector(this.colSelectors.inputCaratMax);
    console.log(this.inputPriceMin, this.inputPriceMax);
    this.clearBtn?.addEventListener('click', () => {
      this.clearFilters();
    });
    this.colInputs?.forEach((input) => {
      input.addEventListener('change', () => {
        this.updateFilter(input);
      });
    });
    this.inputCarat?.forEach((input) => {
      input.addEventListener('input', () => {
        this.handleInputChange(input);
      });
    });

    this.colInputsPrice?.forEach((input) => {
      input?.addEventListener('input', () => {
        debounce(() => {
          this.updatePriceFilter();
        }, 700)();
      });
    });
  }
  clearFilters() {
    this.filterUrls = [];
    this.updateUrl();
    this.fetchProducts();
  }
  handleInputChange(input) {
    let value = input.value.trim();

    value = value.replace(/[^\d-]/g, '');

    if (input.min !== undefined && parseInt(value) < parseInt(input.min)) {
      value = input.min;
    } else if (input.max !== undefined && parseInt(value) > parseInt(input.max)) {
      value = input.max;
    }

    input.value = value;

    debounce(() => {
      this.changeCarat(input);
    }, 500)();
  }

  changeCarat(input) {
    let minCaratValue = null;
    let maxCaratValue = null;
    const filterUrl = input.value;
    const filterUrlName = input.getAttribute('name');
    this.filterUrls = this.filterUrls.filter(url => !url.startsWith(filterUrlName));
    if (this.inputCaratMin) {
      minCaratValue = this.inputCaratMin.value.trim();
    }
    if (this.inputCaratMax) {
      maxCaratValue = this.inputCaratMax.value.trim();
    }
    if (minCaratValue) {
      this.filterUrls.push(`${filterUrlName}=${minCaratValue}`);
    }
    if (maxCaratValue) {
      this.filterUrls.push(`${filterUrlName}=${maxCaratValue}`);
    }
    this.updateUrl();
    if (this.previousUrl != window.location.href) {
      this.fetchProducts();
    }
  }
  updatePriceFilter() {
    let minValue = null;
    let maxValue = null;

    minValue = this.inputPriceMin.value;
    maxValue = this.inputPriceMax.value;

    this.filterUrls = this.filterUrls.filter(url => !url.startsWith('filter.v.price.lte=') && !url.startsWith('filter.v.price.gte='));
    if (minValue == null) {
      this.filterUrls.push(`filter.v.price.gte=`);
    } else {
      this.filterUrls.push(`filter.v.price.gte=${minValue}`);
    }
    if (maxValue == null) {
      this.filterUrls.push(`filter.v.price.lte=`);
    } else {
      this.filterUrls.push(`filter.v.price.lte=${maxValue}`);
    }
    this.updateUrl();
    if (this.previousUrl != window.location.href) {
      this.fetchProducts();
    }
  }
  updateFilter(input) {
    const filterUrl = input.getAttribute('value');
    const filterUrlName = input.getAttribute('name');
    const filterEncodeValue = `${filterUrlName}=${encodeURIComponent(filterUrl)}`;

    if (input.checked) {
      if (!this.filterUrls.includes(filterEncodeValue)) {
        this.filterUrls.push(filterEncodeValue);
      }
    } else {
      const filterDecodeValue = `${filterUrlName}=${decodeURIComponent(filterUrl)}`;
      this.filterUrls = this.filterUrls.filter((url) => url !== filterEncodeValue && url !== filterDecodeValue);
    }

    this.updateUrl();
    this.fetchProducts();
  }

  updateUrl() {
    const collectionHandle = window.location.pathname.split('/').pop();
    const filterQueryString = this.filterUrls.join('&');
    const updatedUrl = `${collectionHandle}?${filterQueryString}`;
    // console.log(updatedUrl);
    window.history.replaceState({}, '', updatedUrl);
  }
  async fetchProducts() {
    document.body.style.overflow = 'hidden';
    this.colloader = document.querySelector(this.colSelectors.loader);
    this.colloader.style.display = 'flex';
    const collectionHandle = window.location.pathname.split('/').pop();
    const apiUrl = `/collections/${collectionHandle}?${this.filterUrls.join('&')}`;
    try {
      const response = await fetch(apiUrl);
      const text = await response.text();
      const parser = new DOMParser();
      const textDoc = parser.parseFromString(text, 'text/html');
      // console.log(textDoc);
      const parentEle = textDoc?.querySelector(this.colSelectors.mainContainer);
      // console.log(parentEle);
      const mainParentEle = document.querySelector(this.colSelectors.mainContainer);
      mainParentEle.parentElement.innerHTML = parentEle.parentElement.innerHTML;
      document.body.style.overflow = '';
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  }
}
customElements.define('byd-col-filters', BydColFilters);
